import * as catalogos from 'app/idiomas/i18n/perfiles/catalogos/zh1';
export const locale = {
  lang: 'zh1',
  data: {
    'RAWDATA': {
      'CATALOGOS': {
        'broker': catalogos.institutos,
      },
      'TITULO': '諮詢原始數據',
      'SUBTITULO': '查詢特定時期平台生成的調查原始數據信息',
      'NOFILE': '未生成',
      'FILTER': '按公司或調查令牌過濾',
      'DOWNLOADFILE': '下載文件',
      'CAMPOS': {
        'anio': '年',
        'broker': '經紀人',
        'brokerCountry': '經紀國',
        'anioRanking': '年度排名',
      },
      'COLUMNAS': {
        'nombre': '公司',
        'producto': '產品類別',
        'surveytoken': '調查令牌',
        'fecha': '日期',
        'acciones': '原始數據',
      },
      'RESULTADOS': {
        'CARGANDO': '加載搜索結果',
        'TITULO': '結果',
        'ENCONTRADAS': '發現的調查總數',
        'DESCARGAR': '下載Excel格式的資料',
        'SINRESULTADOS': '找不到使用指定參數創建的調查'
      }
    }
  }
};
